// @mui material components
import {
  styled,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide
} from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { forwardRef, use, useEffect, useState } from "react";
import Interpret from "./Interpret";
import { Icon } from "@iconify/react";


const props = { window: () => Window }

function Interpretation(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { id } = useParams();

  const handleClose = () => {
    navigate(-1); // go back when closed
  };
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Dialog
      fullScreen
      open={open}
    >
      {/* <AppBar sx={{ position: "relative" }}>
        <Toolbar>
         
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            Interpretation #{id}
          </Typography>
          <IconButton
        onClick={handleClose}
        sx={{ position: "absolute", top: 16, right: 16, zIndex: 1000 }}
      >
        <Icon icon="mdi:close" width={28} height={28} />
      </IconButton>
        </Toolbar>
      </AppBar> */}
      <Interpret id={id} />
    </Dialog>
  );
}

export default Interpretation;